import { MuiTheme } from "theme";
import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    borderLeft: "1px solid #ddd",
    borderRight: "1px solid #ddd",
    "&.details": {
      borderLeft: "none",
      borderRight: "none"
    }
  },
  row: {
    fontSize: 12,
    padding: "6px 10px",
    borderBottom: "1px solid #ddd",
    wordBreak: "break-all",
    "&.details": {
      fontSize: 14,
      padding: "11px 20px 11px 16px",
      [theme.breakpoints.down(Breakpoints.SS_320)]: {
        padding: "11px 12px 11px 12px"
      }
    }
  },
  title: {
    minHeight: 34,
    textTransform: "capitalize",
    display: "flex",
    alignItems: "center"
  },
  content: {
    paddingTop: 9,
    paddingBottom: 14
  },
  loader: {
    marginBottom: 12
  }
}));
